(function(){'use strict';
const all=(s,root=document)=>[...root.querySelectorAll(s)];
const menu=document.querySelector('[data-menu-toggle]'),nav=document.querySelector('#power-mobile-menu');
if(menu&&nav){menu.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')==='true';menu.setAttribute('aria-expanded',String(!open));nav.hidden=open;});all('a',nav).forEach(a=>a.addEventListener('click',()=>{nav.hidden=true;menu.setAttribute('aria-expanded','false')}));}
all('[data-power-gallery]').forEach(g=>{const buttons=all('[data-gallery-image]',g),image=g.querySelector('#power-main-image'),position=g.querySelector('[data-gallery-position]');let current=0;function choose(i){current=(i+buttons.length)%buttons.length;const b=buttons[current];image.src=b.dataset.galleryImage;image.alt=b.dataset.galleryAlt;buttons.forEach((x,j)=>x.setAttribute('aria-pressed',String(j===current)));position.textContent=String(current+1).padStart(2,'0')+' / '+String(buttons.length).padStart(2,'0');}buttons.forEach((b,i)=>b.addEventListener('click',()=>choose(i)));g.querySelector('[data-gallery-prev]').addEventListener('click',()=>choose(current-1));g.querySelector('[data-gallery-next]').addEventListener('click',()=>choose(current+1));});
function sync(id){all('[data-fg-buy]').forEach(b=>{let data;try{data=JSON.parse(b.querySelector('[data-fg-variants]').textContent);}catch(_){return;}const v=data.variants.find(x=>String(x.id)===String(id));if(!v)return;all('[data-fg-bundle]',b).forEach(input=>{input.checked=String(input.value)===String(id);input.closest('[data-fg-bundle-card]').classList.toggle('is-selected',input.checked)});const price=b.querySelector('[data-fg-price]'),submit=b.querySelector('[data-fg-submit]'),label=b.querySelector('[data-fg-label]');if(price)price.textContent=v.price;if(submit)submit.disabled=!v.available;if(label)label.textContent=v.available?data.label:'PRODUKT AUSVERKAUFT';});}
document.addEventListener('change',e=>{if(e.target.matches('[data-fg-bundle]')&&e.target.checked)sync(e.target.value);});
const initially= document.querySelector('[data-fg-bundle]:checked');if(initially)sync(initially.value);
all('[data-open-formula]').forEach(b=>b.addEventListener('click',()=>document.querySelector('#power-formula-dialog')?.showModal()));
all('[data-close-dialog]').forEach(b=>b.addEventListener('click',()=>b.closest('dialog').close()));all('dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}}));
const sticky=document.querySelector('[data-power-sticky]'),hero=document.querySelector('#comprar'),offer=document.querySelector('#oferta');if(sticky&&hero&&offer&&'IntersectionObserver'in window){let passed=false,inOffer=false;const paint=()=>{sticky.hidden=!passed||inOffer;};new IntersectionObserver(entries=>{passed=!entries[0].isIntersecting&&entries[0].boundingClientRect.top<0;paint();}).observe(hero);new IntersectionObserver(entries=>{inOffer=entries[0].isIntersecting;paint();}).observe(offer);}
if(window.CALDORA_PREVIEW){document.querySelector('.header-cart')?.addEventListener('click',e=>{e.preventDefault();const summary=document.querySelector('[data-preview-cart-summary]');if(!summary.textContent)summary.textContent='Wähle ein Set, um deinen Kauf zu simulieren.';document.querySelector('#power-preview-cart')?.showModal();});document.addEventListener('submit',e=>{if(!e.target.classList.contains('power-form'))return;e.preventDefault();e.stopImmediatePropagation();const id=new FormData(e.target).get('id'),selected=e.target.querySelector('input[name="id"]:checked');if(!id||!selected)return;const kit=selected.closest('[data-fg-bundle-card]');document.querySelector('[data-preview-cart-summary]').textContent=kit.querySelector('.kit-text strong').textContent+' · '+kit.querySelector('.kit-price strong').textContent;document.querySelector('[data-power-cart-count]').textContent='1';document.querySelector('#power-preview-cart').showModal();},true);}
})();

/* Keep one selected kit when a customer returns from checkout and buys again. */
(function () {
  'use strict';
  if (window.caldoraKitCartReady) return;
  window.caldoraKitCartReady = true;
  var busy = false;
  var generation = 0;
  var savedControls = [];
  function cartRoot(buy) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || buy.dataset.fgCartRoot || '/';
    if (root.charAt(0) !== '/' || root.indexOf('//') === 0) root = '/';
    return root.replace(/\/?$/, '/');
  }
  function setBusy(value) {
    if (value) {
      savedControls = [];
      document.querySelectorAll('[data-fg-buy] form').forEach(function (form) {
        form.setAttribute('aria-busy', 'true');
        form.querySelectorAll('input[name="id"], select[name="id"], button[type="submit"]').forEach(function (control) {
          savedControls.push({ element: control, disabled: control.disabled });
          control.disabled = true;
        });
      });
    } else {
      savedControls.forEach(function (entry) { entry.element.disabled = entry.disabled; });
      savedControls = [];
      document.querySelectorAll('[data-fg-buy] form').forEach(function (form) { form.removeAttribute('aria-busy'); delete form.dataset.fxSent; });
    }
    busy = value;
  }
  function cartShape(cart) {
    if (!cart || !Array.isArray(cart.items)) throw new Error('Invalid cart response');
    return cart;
  }
  async function request(root, endpoint, body, ticket) {
    if (ticket !== generation) throw new Error('Page changed');
    var options = { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (body instanceof FormData) options.body = body;
    else if (body) { options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
    var response = await fetch(root + endpoint, options);
    var data = await response.json();
    if (ticket !== generation) throw new Error('Page changed');
    if (!response.ok) {
      var message = typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : '';
      throw new Error(message || 'Cart update failed');
    }
    return data;
  }
  async function replaceKit(root, productId, variantId, formData, ticket) {
    function belongs(item) { return String(item.product_id) === productId; }
    function selected(cart) { return cart.items.find(function (item) { return belongs(item) && String(item.variant_id) === variantId; }); }
    var cart = cartShape(await request(root, 'cart.js', null, ticket));
    // Add the new kit before removing the previous one: unavailable kits leave
    // the existing selection untouched. Retries first inspect the current cart.
    if (!selected(cart)) {
      await request(root, 'cart/add.js', formData, ticket);
      cart = cartShape(await request(root, 'cart.js', null, ticket));
    }
    var attempts = 0;
    while (true) {
      var keep = selected(cart);
      if (!keep) throw new Error('Selected kit is missing from the cart');
      if (++attempts > 100) throw new Error('Cart changed while updating');
      if (keep.quantity !== 1) {
        cart = cartShape(await request(root, 'cart/change.js', { id: keep.key, quantity: 1 }, ticket));
        continue;
      }
      var extra = cart.items.find(function (item) { return belongs(item) && item.key !== keep.key; });
      if (!extra) break;
      // Keys can change when Shopify recalculates discounts. Read each next key
      // from the latest returned cart rather than keeping stale line indexes.
      cart = cartShape(await request(root, 'cart/change.js', { id: extra.key, quantity: 0 }, ticket));
    }
    var verified = cartShape(await request(root, 'cart.js', null, ticket));
    var kits = verified.items.filter(belongs);
    if (kits.length !== 1 || String(kits[0].variant_id) !== variantId || kits[0].quantity !== 1) throw new Error('Cart could not be verified');
    return verified;
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var buy = form && form.closest ? form.closest('[data-fg-buy][data-fg-product-id]') : null;
    if (!buy || form.tagName !== 'FORM' || !form.classList.contains('fg-product-form')) return;
    event.preventDefault();
    if (busy) return;
    var error = form.querySelector('[data-fg-cart-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
    // Capture the chosen option before disabling controls in both buy boxes.
    var formData = new FormData(form);
    var productId = String(buy.dataset.fgProductId || '');
    var variantId = String(formData.get('id') || '');
    var variants;
    try { variants = JSON.parse(buy.querySelector('[data-fg-variants]').textContent).variants; } catch (_) { variants = []; }
    var variant = variants.find(function (item) { return String(item.id) === variantId && item.available; });
    if (!/^\d+$/.test(productId) || !variant) {
      if (error) { error.textContent = 'Wähle ein verfügbares Set, um fortzufahren.'; error.hidden = false; }
      return;
    }
    var root = cartRoot(buy);
    var target;
    try {
      target = new URL(String(formData.get('return_to') || root + 'cart'), window.location.origin);
      if (target.origin !== window.location.origin || !/^https?:$/.test(target.protocol)) throw new Error('Invalid destination');
    } catch (_) { target = new URL(root + 'cart', window.location.origin); }
    formData.set('quantity', '1');
    formData.delete('return_to');
    setBusy(true);
    var ticket = ++generation;
    var start = Date.now();
    async function run() {
      try {
        var execute = function () { return replaceKit(root, productId, variantId, formData, ticket); };
        // Cooperating tabs serialize the same action where Web Locks is supported.
        if (navigator.locks && navigator.locks.request) await navigator.locks.request('caldora-kit-selection', execute);
        else await execute();
        // Retain the existing opportunity for checkout tracking to dispatch.
        await new Promise(function (resolve) { setTimeout(resolve, Math.max(0, 450 - (Date.now() - start))); });
        if (ticket !== generation) return;
        window.location.assign(target.href);
      } catch (_) {
        if (ticket !== generation) return;
        setBusy(false);
        if (error) {
          error.textContent = 'Dein Warenkorb konnte nicht aktualisiert werden. Prüfe deine Verbindung und die Verfügbarkeit des Sets und versuche es erneut.';
          error.hidden = false;
          error.focus();
        }
      }
    }
    run();
  }, true);
  // Browsers may restore a disabled checkout button from their back/forward cache.
  window.addEventListener('pagehide', function () { generation += 1; });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted || !busy) { generation += 1; setBusy(false); }
  });
})();
